import { render, staticRenderFns } from "./ErrorFeedbackModal.vue?vue&type=template&id=82e84784&"
import script from "./ErrorFeedbackModal.vue?vue&type=script&lang=js&"
export * from "./ErrorFeedbackModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports